import {Component, render} from 'preact';
import cx from 'classnames';
import {jquerySmartResize, Waypoints} from '@modules/lazy-imports';
import Icon from '@components/common/Icon';
import $ from '@modules/jquery-import';

class PageNavigation extends Component {
    constructor ( props ) {
        super( props );

        this.state = {
            nodeList: props.nodeList,
            navList: [],
            activeId: null,
            indicator: {
                position: 0,
                width: 0
            }
        };
    }

    /**
     * Static initializer
     * Calling this method on pag init causes this component to attach itself to the DOM using the specified selector
     * This method is safe since there should only ever be one instance of this component per page
     */
    static initialize ( selector ) {
        if ( this.__init__ ) {
            return false;
        }

        this.__init__ = true;

        const ATTR_NAV_ITEM = 'data-inline-nav-item';
        let navList = document.querySelectorAll( `[${ATTR_NAV_ITEM}]` );

        if ( navList.length ) {
            const nodeList = Array.from( navList ).map( node => {
                return {
                    el: node,
                    id: node.getAttribute( 'name' ),
                    label: node.getAttribute( ATTR_NAV_ITEM )
                };
            } );

            var headerMain = document.querySelector( selector );
            const entryNode = document.createElement( 'div' );
            headerMain.appendChild( entryNode );
            if ( headerMain ) {
                render( <PageNavigation nodeList={nodeList} showBackToTop={false}/>, entryNode );
            }
        }
    }

    async componentDidMount () {
        this.setState( {
            navList: Array.from( this.nav.querySelectorAll( 'a' ) )
        } );

        await Waypoints();

        $( window ).on( 'load', e => {
            this.state.nodeList.forEach( node => {
                new Waypoint( {
                    element: node.el,
                    handler: this.handleWaypoint( 'down' ),
                    offset: 120
                } );
                new Waypoint( {
                    element: node.el,
                    handler: this.handleWaypoint( 'up' ),
                    offset: 120 - node.el.getBoundingClientRect().height
                } );
            } );
        } );

        await jquerySmartResize();
        // update indicator position on window resize
        $( window ).smartresize( e => {
            this.setIndicatorPosition( this.state.activeId )
        } );
    }

    handleWaypoint ( handleDir ) {
        const self = this;
        return function ( currentDir ) {
            if ( currentDir !== handleDir || $( upi.conf.SCROLL_CONTEXT ).data( 'is-scroll-animating' ) ) {
                // only set active if page scroll is not hijacked
                return;
            }
            const id = this.element.getAttribute( 'id' );

            self.setActiveNavItem( id );
        };
    }

    setActiveNavItem ( id ) {
        this.setState( {activeId: id} );
        this.setIndicatorPosition( id );
    }

    setIndicatorPosition ( id ) {
        const node = this.state.navList.find( node => node.dataset.nodeid === id );

        // reset to "0" if node not set
        const {width, x} = Boolean( node )
            ? node.getBoundingClientRect()
            : {x: 0, width: 0};

        this.setState( {
            indicator: {
                position: x,
                width: width
            }
        } );

    }

    getIndicatorStyle () {
        const {indicator} = this.state;
        return {
            transform: `translate3d(${indicator.position}px,0,0)`,
            opacity: 1.0,
            width: indicator.width
        };
    }

    render ( {nodeList, showBackToTop}, context ) {
        if ( !nodeList.length ) {
            return null;
        }

        const navItemClass = ( isActive ) => cx( 'py-4 px-2', {
            'nav-item--active': isActive
        } );

        return (
            <div id="page-secondary-nav" className="page-secondary-nav">
                <nav ref={ref => this.nav = ref} className="contain-content relative flex justify-between pr-12">

                    {nodeList.map( node =>
                        <a data-auto-scroll
                           data-nodeid={node.id}
                           onClick={( e ) => this.setActiveNavItem( node.id )}
                           className={navItemClass( this.state.activeId === node.id )}
                           href={`#${node.id}`}>{node.label}</a> )
                    }

                    {showBackToTop &&
                    <a data-auto-scroll href="#top"
                       onClick={( e ) => this.setActiveNavItem( null )}
                       className="page-secondary-nav--top px-4 py-3 mr-2 bg-brand text-white hover:text-white rounded-b shadow-1">
                        <Icon.ui name="arrow-up" className="icon text-xl block"/>
                        Top
                    </a>
                    }

                </nav>
                <span className="nav-selection-indicator" style={this.getIndicatorStyle()}></span>
            </div>
        );
    }
}

PageNavigation.defaultProps = {
    showBackToTop: true
};

export default PageNavigation;